// Imports
import moment from 'moment'

// Date Filter
export default (value) => {
  if (!value) return ''

  return moment(value).format('MMM DD, YYYY')
}
